<template>
    <span
        class="absolute -top-2.5 right-3 inline-flex items-center rounded-full bg-white border border-slate-200 px-2 py-0.5 text-xs font-medium text-slate-500 shadow-sm"
    >
        Last used
    </span>
</template>
